'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'rv';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f7be';
var svgPathData = 'M248 16c-4.4 0-8 3.6-8 8l0 8 128 0 0-8c0-4.4-3.6-8-8-8L248 16zM224 32l0-8c0-13.3 10.7-24 24-24L360 0c13.3 0 24 10.7 24 24l0 8 126.4 0c53.9 0 97.6 43.7 97.6 97.6c0 16.8-13.6 30.4-30.4 30.4L408 160c-13.3 0-24 10.7-24 24l0 208c0 4.4-3.6 8-8 8l-91.3 0c2.2 7.6 3.3 15.7 3.3 24c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-10.5 1.8-20.6 5.2-30L22.9 324.8C8.5 314.3 0 297.5 0 279.7L0 88C0 57.1 25.1 32 56 32l168 0zM384 48l-16 0L240 48l-16 0L56 48C33.9 48 16 65.9 16 88l0 191.7c0 12.7 6.1 24.7 16.3 32.3l91.8 67.4C139.5 353.4 167.7 336 200 336c34.2 0 63.8 19.5 78.4 48l89.6 0 0-200c0-22.1 17.9-40 40-40l169.6 0c8 0 14.4-6.4 14.4-14.4C592 84.5 555.5 48 510.4 48L384 48zM200 496a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm288 0a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm0-160a88 88 0 1 1 0 176 88 88 0 1 1 0-176zM272 128l-160 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zM112 112l160 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm304 88c0-4.4 3.6-8 8-8l93.1 0c8.8 0 17.4 2.9 24.4 8.3l82.9 63.8c9.8 7.6 15.6 19.3 15.6 31.7l0 64.2c0 22.1-17.9 40-40 40l-8 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l8 0c13.3 0 24-10.7 24-24l0-64.2c0-2.7-.4-5.3-1.3-7.8L424 288c-4.4 0-8-3.6-8-8s3.6-8 8-8l184.5 0-76.7-59c-4.2-3.2-9.3-5-14.6-5L424 208c-4.4 0-8-3.6-8-8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRv = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;